import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import peppoSvg from 'components/icons/img/peppo.svg';
import Heading from 'components/ui/typography/Heading';
import Text from 'components/ui/typography/Text';

import { track } from 'helpers/rudderstack-helper';

import { ErrorFallbackWrapper } from './styled';

export function ErrorFallback() {
  useEffect(() => {
    track('Oops Page Rendered');
    datadogRum.startView('oops');
  }, []);

  return (
    <ErrorFallbackWrapper>
      <Heading variant="h1">Oops!</Heading>
      <Text>It seems something went wrong.</Text>
      <img src={peppoSvg} />
    </ErrorFallbackWrapper>
  );
}
